import {Column} from 'react-table'
import {LicensesProject} from './LicensesProject'
import {LicensesDocument} from './LicensesDocument'
import {LicensesActionsCell} from './LicensesActionsCell'
import {LicensesCustomHeader} from './LicensesCustomHeader'
import {Licenses} from '../../core/_models'
import {LicensesEntrepreneur} from './LicensesEntrepreneur'
import {LicensesEnterprises} from './LicensesEnterprises'
import {LicensesIssuerOrgan} from './LicensesIssuerOrgan'
import {LicensesNumber} from './LicensesNumber'
import {LicensesIssuerDate} from './LicensesIssuerDate'
import {LicensesExpirationDate} from './LicensesExpirationDate'
import {LicensesLimitRenovation} from './LicensesLimitRenovation'
import {LicensesStatus} from './LicensesStatus'
import {LicensesFields} from './LicensesFields'

const LicensesColumns: ReadonlyArray<Column<Licenses>> = [
  //HEADER COLUMN - PROJECT
  {
    Header: (props) => (
      <LicensesCustomHeader
        tableProps={props}
        title='PROJECT.PROJECT_PLURAL'
        className='fs-9 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'project',
    Cell: ({...props}) => <LicensesProject Licenses={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - LICENSE TYPE
  {
    Header: (props) => (
      <LicensesCustomHeader
        tableProps={props}
        title='LICENSES.TYPE_RED'
        className='fs-9 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'license_type',
    Cell: ({...props}) => <LicensesDocument Licenses={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - ENTREPRENEUR
  {
    Header: (props) => (
      <LicensesCustomHeader
        tableProps={props}
        title='ENTREPRENEUR.ENTREPRENEUR_SINGLE'
        className='fs-9 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'entrepreneur',
    Cell: ({...props}) => <LicensesEntrepreneur Licenses={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - ENTERPRISES
  {
    Header: (props) => (
      <LicensesCustomHeader
        tableProps={props}
        title='ENTERPRISES.TITLE'
        className='fs-9 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'enterprises',
    Cell: ({...props}) => <LicensesEnterprises Licenses={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - ISSUE ORGAN ***
  {
    Header: (props) => (
      <LicensesCustomHeader
        tableProps={props}
        title='LICENSES.ISSUE_ORGAN_RED'
        className='fs-9 min-w-auto text-center min-w-125px flex-row-fluid flex-center'
      />
    ),
    id: 'issuer_organ',
    Cell: ({...props}) => <LicensesIssuerOrgan Licenses={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - license_number ***
  {
    Header: (props) => (
      <LicensesCustomHeader
        tableProps={props}
        title='LICENSES.NUMBER_RED'
        className='fs-9 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'license_number',
    Cell: ({...props}) => <LicensesNumber Licenses={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - ISSUE DATE ***
  {
    Header: (props) => (
      <LicensesCustomHeader
        tableProps={props}
        title='LICENSES.ISSUE_DATE_RED'
        className='fs-9 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'issuer_date',
    Cell: ({...props}) => <LicensesIssuerDate Licenses={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - expiration_date ***
  // {
  //   Header: (props) => (
  //     <LicensesCustomHeader
  //       tableProps={props}
  //       title='LICENSES.EXPIRATION_DATE'
  //       className='fs-9 min-w-auto text-center flex-row-fluid flex-center'
  //     />
  //   ),
  //   id: 'expiration_date',
  //   Cell: ({...props}) => <LicensesExpirationDate Licenses={props.data[props.row.index]} />,
  // },

  //HEADER COLUMN -  limit_renovation ***
  {
    Header: (props) => (
      <LicensesCustomHeader
        tableProps={props}
        title='LICENSES.LIMIT_DATE'
        className='fs-9 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'limit_renovation',
    Cell: ({...props}) => <LicensesLimitRenovation Licenses={props.data[props.row.index]} />,
  },

  //HEADER COLUMN -  Status ***
  {
    Header: (props) => (
      <LicensesCustomHeader
        tableProps={props}
        title='COMMON.STATUS'
        className='fs-9 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'status',
    Cell: ({...props}) => <LicensesStatus Licenses={props.data[props.row.index]} />,
  },

  //HEADER COLUMN -  FIELDS ***
  {
    Header: (props) => (
      <LicensesCustomHeader
        tableProps={props}
        title='FIELD.FIELD_SINGLE'
        className='fs-9 min-w-auto text-center flex-row-fluid flex-center'
      />
    ),
    id: 'fields',
    Cell: ({...props}) => <LicensesFields Licenses={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - ACTIONS
  {
    Header: (props) => (
      <LicensesCustomHeader tableProps={props} title='MENU.ACTIONS' className='fs-9 min-w-auto ' />
    ),
    id: 'actions',
    Cell: ({...props}) => <LicensesActionsCell data={props.data[props.row.index]} />,
  },
]

export {LicensesColumns}
